import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import ListItem from './ListItem';
import stylesheet, { directions } from 'src/Constants/stylesheet';

export type ListMobileProps = {
    page: ListDto;
};

const styles = {
    container: {
        position: 'relative',
        overflow: 'hidden',
        marginTop: 43,
        height: '100%',
        boxSizing: 'border-box'
    },
    items: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'auto',
        overflowScrolling: 'touch',
        ...stylesheet.PaddingGutter(1, directions.sides)
    }
}
type Props =
    ListMobileProps &
    StyledComponentProps<keyof typeof styles>;

class ListMobile extends React.PureComponent<Props> {

    scrollingContainer: HTMLElement | null = null;

    constructor(props: Props) {
        super(props);
    }
    
    public render() {
        const { classes, page: { Projects, UID } } = this.props;

        return (
            <div className={classNames(classes!.container)}>
                <div id="targetElementId" className={classNames(classes!.items)}>
                    {Projects.map(p =>
                        <ListItem
                            key={p.UID}
                            project={p}
                            parentUID={UID}
                        />)
                    }
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ListMobile);


// WEBPACK FOOTER //
// ./src/Components/ListMobile.tsx